import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, ChevronDown } from 'lucide-react';
export function ModulesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const modules = [{
    title: 'Módulo 1 – Historia Clínica Pediátrica Profesional',
    desc: 'Plantillas listas para documentar cada consulta de forma clara, completa y profesional en minutos.',
    items: ['Historia clínica pediátrica inicial', 'Registro de consulta de control por edad', 'Ficha de antecedentes perinatales y familiares', 'Registro de urgencias pediátricas', 'Plantilla de resumen clínico para derivaciones']
  }, {
    title: 'Módulo 2 – Desarrollo Infantil por Etapas',
    desc: 'Guías estructuradas para evaluar y documentar el desarrollo del paciente pediátrico por rango etario.',
    items: ['Hitos del desarrollo motor por edad', 'Indicadores de desarrollo del lenguaje', 'Señales de alerta por etapa evolutiva', 'Fichas de seguimiento del desarrollo cognitivo', 'Registro de desarrollo socioemocional']
  }, {
    title: 'Módulo 3 – Protocolos de Consulta Pediátrica',
    desc: 'Flujos de trabajo paso a paso para cada tipo de consulta, sin improvisar nunca más.',
    items: ['Protocolo de consulta de control sano', 'Protocolo de consulta por enfermedad aguda', 'Protocolo de seguimiento de paciente crónico', 'Protocolo de primera consulta', 'Protocolo de consulta de urgencia']
  }, {
    title: 'Módulo 4 – Comunicación con Padres y Familias',
    desc: 'Recursos y guías para comunicar diagnósticos, indicaciones y seguimientos de forma clara y efectiva.',
    items: ['Guía de comunicación de diagnósticos difíciles', 'Plantillas de indicaciones para padres por patología', 'Recursos visuales explicativos para familias', 'Guía de respuesta ante preguntas frecuentes de padres', 'Plantilla de consentimiento informado pediátrico']
  }, {
    title: 'Módulo 5 – Derivaciones y Seguimiento Interdisciplinario',
    desc: 'Herramientas para derivar con información completa y hacer seguimiento del paciente entre especialistas.',
    items: ['Plantillas de derivación por especialidad', 'Registro de seguimiento interdisciplinario', 'Ficha de evolución mensual del paciente', 'Registro de objetivos clínicos alcanzados', 'Informe de evolución para obras sociales y prepagas']
  }];
  return <section className="py-12 bg-gray-50" data-id="element-71">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-73">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-3" data-id="element-74">
            ¿Qué incluye el Sistema PRO?
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-[12px]" data-id="element-75">
            Un sistema completo de recursos profesionales listos para usar.
            Incluye 5 módulos con plantillas, protocolos y herramientas clínicas
            que podés aplicar directamente en tu práctica pediátrica desde el
            primer día.
          </p>
        </motion.div>

        <div className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm divide-y divide-gray-100" data-id="element-76">
          {modules.map((mod, index) => {
          const isOpen = openIndex === index;
          return <div key={index} data-id="element-77">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-gray-50 transition-colors" data-id="element-78">
                  <span className="font-semibold text-gray-900 text-sm md:text-base pr-4" data-id="element-79">
                    {mod.title}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-80" />
                </button>
                <AnimatePresence initial={false} data-id="element-81">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-82">
                      <div className="px-5 pb-4 pt-1" data-id="element-83">
                        <p className="text-gray-500 text-sm mb-3" data-id="element-84">{mod.desc}</p>
                        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-1.5" data-id="element-85">
                          {mod.items.map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-86">
                              <CheckCircle2 className="w-4 h-4 text-emerald-500 flex-shrink-0" data-id="element-87" />
                              <span className="text-gray-600 text-sm" data-id="element-88">
                                {item}
                              </span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}